import { atomWithStorage } from 'jotai/utils';

export const publicTournamentCategoryId = atomWithStorage<string | null>(
  'publicTournamentCategoryId',
  null,
  undefined,
  {
    getOnInit: true,
  }
);

export const publicTournamentStage = atomWithStorage<string | null>(
  'publicTournamentStage',
  null,
  undefined,
  {
    getOnInit: true,
  }
);
